/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_TitleInputs */



/**
* | output |
* | --- |
* | "Automix Settings" |
*
* @param {Audio_Description_Export_Automix_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_title = /** @type {((inputs?: Audio_Description_Export_Automix_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres d'automixage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automix-Einstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni di Automix")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки автомикса")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de mezcla automática")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动混合设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オートミックス設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑटोमिक्स सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de automixagem")
	return /** @type {LocalizedString} */ ("Automix Settings")
});